import { PERFORMANCE_NAVIGATION_TABS } from "./Constants";

import { BUSINESS_RULES_NAVIGATION_TABS } from "./Constants";

export const filteredTabs = (routes: any[]) =>
  routes.filter(
    (route) =>
      route.link !==
        `/business-rules/${BUSINESS_RULES_NAVIGATION_TABS.AUTOMATION_RULES}` &&
      route.link !== `/performance/${PERFORMANCE_NAVIGATION_TABS.PRODUCT}` &&
      route.link !== `/performance/${PERFORMANCE_NAVIGATION_TABS.CONVERSION}` &&
      route.link !== `/performance/${PERFORMANCE_NAVIGATION_TABS.REVENUE}`,
  );
